import { Comment as CommentProps } from 'pleinchamp-api-client';
import React, { ComponentPropsWithRef, FC, forwardRef } from 'react';
import { Text } from '@components/Text/Text.component';
import { formatDateCompact } from '@utils/date';
import classnames from 'classnames';

import styles from './Comment.module.scss';

type Props = ComponentPropsWithRef<'div'> & { comment: CommentProps };

const Comment: FC<Props> = forwardRef(({ comment, className, ...rest }, commentRef) => {
  const { publishDate, username, body } = comment;
  const rootClassName = classnames(styles.comment, className);
  return (
    <div ref={commentRef} className={rootClassName} {...rest}>
      <Text tag="p" variant="h6">
        {formatDateCompact(publishDate)}
      </Text>
      <Text tag="p" variant="h4">
        {username}
      </Text>
      <Text variant="small">{body}</Text>
    </div>
  );
});

export { Comment };
